import { z } from "zod";
const TIME_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;
const timeSchema = z
    .string()
    .optional()
    .refine((val) => !val || TIME_REGEX.test(val), { message: "Format HH:mm requis (ex: 16:00)" });
const optionalUrl = z
    .string()
    .optional()
    .refine((val) => !val || z.url().safeParse(val).success, { message: "URL invalide" });
export const createPropertySchema = z.object({
    name: z.string().min(1).max(200),
    address: z.string().min(1).max(500),
    capacity: z.number().int().min(1).max(100),
    description: z.string().max(5000).optional(),
    photos: z.array(z.url()).max(20).optional().default([]),
    google_review_url: optionalUrl,
    tourism_classification: z.string().max(200).optional(),
    gite_classification: z.string().max(200).optional(),
    signature_city: z.string().max(200).optional(),
    tourist_tax_per_adult_cents: z.number().int().min(0).optional(),
    security_deposit_cents: z.number().int().min(0),
    security_deposit_with_pets_cents: z.number().int().min(0).optional(),
    check_in_time: timeSchema,
    check_out_time: timeSchema,
    widget_enabled: z.boolean().optional().default(true),
    pets_allowed: z.boolean().optional().default(false),
});
